import React from "react";

/**
 * Map of every Lead.status enum value to a Tailwind class set so the
 * pill colors track the workflow stages used by the API. "closed" is
 * a legacy status retained for backwards compatibility.
 */
const STATUS_STYLES = {
  new: "bg-blue-50 text-blue-700 ring-blue-600/20",
  contacted: "bg-indigo-50 text-indigo-700 ring-indigo-600/20",
  qualified: "bg-purple-50 text-purple-700 ring-purple-600/20",
  demo_scheduled: "bg-amber-50 text-amber-800 ring-amber-600/30",
  won: "bg-green-50 text-green-700 ring-green-600/20",
  lost: "bg-rose-50 text-rose-700 ring-rose-600/20",
  closed: "bg-gray-100 text-gray-700 ring-gray-500/20",
};

const STATUS_LABELS = {
  new: "New",
  contacted: "Contacted",
  qualified: "Qualified",
  demo_scheduled: "Demo scheduled",
  won: "Won",
  lost: "Lost",
  closed: "Closed",
};

/**
 * Small colored pill summarizing a lead's workflow stage. Used by the
 * Leads list table and the lead detail header.
 */
const StatusPill = ({ status, className = "" }) => {
  const key = STATUS_STYLES[status] ? status : "new";
  const tone = STATUS_STYLES[key];
  const label = STATUS_LABELS[status] || status || "—";
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${tone} ${className}`}
    >
      {label}
    </span>
  );
};

export default StatusPill;
